import React, { PureComponent } from 'react'
import {
    SpinnerSize, Spinner, MessageBarType,
} from '@fluentui/react'
import history from 'helpers/history'
import InvalidEntityError from 'requests/errors/invalidEntityError'
// eslint-disable-next-line import/named
import { AppProps } from 'app'
import Status from 'types/status'
import CancelRequestError from 'requests/errors/cancelRequestError'
import NotImplementedError from 'requests/errors/notImplementedError'
import UnauthorizedError from 'requests/errors/unauthorizedError'
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google'

/** @debug {AppProps} */

/**
 * @augments {React.PureComponent<AppProps>}
 */
export default class Login extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            /** @type {Status} Current status of the component */
            status: Status.IDLE,
        }
    }

    componentDidMount() {
        const {
            setBreadcrumb, setCommand, isAuthenticated, messageBar, setMessageBar,
        } = this.props

        setBreadcrumb([])
        setCommand([])

        if (messageBar.type !== MessageBarType.error)
            setMessageBar({ isDisplayed: false })

        if (isAuthenticated)
            history.push('/')
    }

    componentWillUnmount() {
        this.usersHandlerLogin?.cancel()
    }

    /**
     * @param {string} googleToken googleToken
     */
    login(googleToken) {
        const { usersHandler, signIn } = this.props
        this.setState({ status: Status.PENDING }, async () => {
            try {
                this.usersHandlerLogin = usersHandler.login(googleToken)
                const user = await this.usersHandlerLogin.fetch()
                signIn({ accessToken: user.accessToken, refreshToken: user.refreshToken })
                history.push('/')
            } catch (error) {
                this.setState({ status: Status.REJECTED }, () => {
                    switch (error?.constructor) {
                        case CancelRequestError:
                        case UnauthorizedError: break
                        case NotImplementedError:
                        case InvalidEntityError:
                        default:
                            // eslint-disable-next-line no-console
                            console.error(error)
                            break
                    }
                })
            }
        })
    }

    render() {
        const { status } = this.state
        const { setMessageBar } = this.props

        return (
            <main>
                <div
                    className="flex-row"
                    style={{ marginTop: '.5rem' }}
                >
                    {status === Status.PENDING ? (
                        <Spinner size={SpinnerSize.small} />
                    ) : (
                        <GoogleOAuthProvider
                            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                        >
                            <GoogleLogin
                                onSuccess={response => {
                                    this.login(response.credential)
                                }}
                                onError={() => {
                                    setMessageBar({
                                        isDisplayed: true,
                                        type: MessageBarType.error,
                                        message: 'Une erreur est survenue.',
                                    })
                                }}
                            />
                        </GoogleOAuthProvider>
                    )}

                </div>
            </main>
        )
    }
}
